import styled, { css } from 'styled-components';
import { palette } from '../../theme/colors';

export const MessagesContainer = styled.div`
  width: 100%;
  background-color: ${palette.gunmetal};
  padding: 1rem;
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .message-link {
    color: ${palette.honeyYellow};
  }
`;

type TopRowProps = {
  marginBottom?: string;
};

export const TopRow = styled.div<TopRowProps>`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: ${props => props.marginBottom};
  gap: 10px;
`;

export const CreatorName = styled.p`
  font-size: 0.8rem;
  font-weight: 500;
  color: ${palette.honeyYellow};
  word-break: break-word;
`;

export const Subject = styled.p`
  font-size: 0.75rem;
  font-weight: 600;
  max-width: 7.2rem;
  word-break: break-word;
  text-align: right;
`;

export const SimpleText = styled.p`
  font-size: 0.75rem;
  font-weight: 400;
  word-break: break-word;
  white-space: pre-line;
  a {
    text-decoration: none;
  }
`;

export const ToggleButton = styled.button`
  cursor: pointer;
  margin-top: -0.5rem;
  margin-right: -0.8rem;
  background-color: transparent;
  border: none;
`;

export const IconImage = styled.img`
  object-fit: cover;
`;

export const ButtonGroupContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 1rem 1rem;
`;

export const OnCallAlertEnded = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 1rem 1rem;
  background-color: ${palette.stormGray};
  font-family: 'Roboto-Medium';
  font-size: 1rem;
  font-weight: 500;
  text-align: center;
  color: ${palette.white};
`;

export const OnCallAlertStatus = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 0.5rem 1rem;
  background-color: ${palette.stormGray};
  font-family: 'Roboto-Medium';
  font-size: 1rem;
  font-weight: 400;
  text-align: center;
  color: ${palette.white};
  line-height: 30px;
`;

export const ProvideStatusText = styled.h3`
  font-family: 'Roboto-Medium';
  font-size: 1.1rem;
  font-weight: 500;
  text-align: center;
  margin-bottom: 1rem;
  color: ${palette.honeyYellow};
`;
type ResponseButtonProps = {
  red?: boolean;
  $unHighlight?: boolean;
};

export const ResponseButton = styled.button<ResponseButtonProps>`
  width: 50%;
  border-radius: 2rem;
  height: 3rem;
  cursor: pointer;
  background-color: ${props => (props.red ? palette.tartOrange : palette.appleGreen)};

  ${props =>
    props.$unHighlight &&
    css`
      background-color: ${palette.prussianBlue2};
    `};
  color: ${palette.white};
  border: 2px solid ${props => (props.red ? palette.tartOrange : palette.appleGreen)};
  margin-bottom: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  gap: 1rem;
`;

export const Text = styled.p`
  font-family: 'Roboto-Medium';
  font-size: 1rem;
  font-weight: 500;
  text-align: center;
`;

export const Icon = styled.img`
  object-fit: cover;
  padding-left: 0.5rem;
`;

export const ResponseListContainer = styled.div<{ $removedHeight?: number }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 1.4375rem;
  padding-bottom: 3px;
  width: 100%;

  height: calc(100% - ${props => props.$removedHeight || 0}px);
`;

export const ResponseRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: strech;
  width: 100%;
  cursor: pointer;
`;
type SwitchButtonProps = {
  align?: string;
  active?: boolean;
};

export const SwitchButton = styled.div<SwitchButtonProps>`
  display: flex;
  justify-content: ${props => props.align};
  align-items: center;
  width: 33%;
  padding-bottom: 0.4375rem;
  ${props =>
    props.active &&
    css`
      border-radius: 2px;
    `};
  border-bottom: ${props =>
    props.active ? `solid 2px ${palette.honeyYellow}` : `solid 1px ${palette.queenBlue}`};
`;

export const UserWrapper = styled.div`
  margin-top: 1rem;
  width: 100%;
  flex-grow: 1;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

type SwitchButtonTextProps = {
  active?: boolean;
  isNoStatus?: boolean;
};

export const SwitchButtonText = styled.p<SwitchButtonTextProps>`
  font-family: 'Roboto-Medium';
  font-size: 0.8rem;
  font-weight: 300;
  text-align: center;
  border-radius: 0.3rem;
  padding: 0.2rem ${props => (props.isNoStatus ? '0.05rem' : '0.5rem')};
  color: ${props => (props.active && props.isNoStatus ? palette.honeyYellow : palette.white)};
  background-color: ${props => props.color};
`;

type CountTextProps = {
  active?: boolean;
};
export const CountText = styled.p<CountTextProps>`
  font-family: 'Roboto-Medium';
  font-size: 0.8rem;
  font-weight: 500;
  text-align: center;
  padding-left: 0.2rem;
  color: ${props => (props.active ? palette.honeyYellow : palette.white)};
`;

export const UserContainer = styled.div`
  cursor: pointer;
  width: 100%;
  display: flex;
  justify-content: space-between;
  border-bottom: solid 1px ${palette.tinyBorder};
  padding: 0.52rem 0;
  cursor: pointer;
`;

export const UserColumn = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const UserButton = styled.button`
  cursor: pointer;
  font-weight: 500;
  font-size: 0.875rem;
  color: ${palette.white};
  border: none;
  text-align: left;
  background-color: transparent;
  padding-left: 0.5rem;
`;

export const UserLocation = styled.img`
  object-fit: cover;
`;

type UserStatusProps = {
  paddingRight?: boolean;
};

export const UserStatus = styled.p<UserStatusProps>`
  font-size: 0.75rem;
  font-weight: 400;
  text-align: center;
  padding-right: ${props => (props.paddingRight ? '0.5rem' : '0')};
  color: ${palette.silver};
`;

export const EmptyList = styled.div`
  flex-grow: 1;

  display: flex;
  justify-content: center;
  align-items: center;
  p {
    margin-bottom: 8vh;
    font-family: 'Roboto-Regular';
    font-size: 0.8125rem;
    font-weight: 400;
    text-align: center;
    color: ${palette.silver};
  }
`;
